/** Croatian OIB: 11 digits, ISO 7064 MOD 11,10 check digit. */
export function isValidOib(oib: string): boolean {
  if (!/^\d{11}$/.test(oib)) return false;
  let a = 10;
  for (let i = 0; i < 10; i++) {
    a = (a + parseInt(oib[i]!, 10)) % 10;
    if (a === 0) a = 10;
    a = (a * 2) % 11;
  }
  let check = 11 - a;
  if (check === 10) check = 0;
  return check === parseInt(oib[10]!, 10);
}

/** Make a valid OIB from 10 leading digits (used for obviously fake demo data). */
export function oibWithCheckDigit(first10: string): string {
  if (!/^\d{10}$/.test(first10)) throw new Error("need 10 digits");
  let a = 10;
  for (let i = 0; i < 10; i++) {
    a = (a + parseInt(first10[i]!, 10)) % 10;
    if (a === 0) a = 10;
    a = (a * 2) % 11;
  }
  let check = 11 - a;
  if (check === 10) check = 0;
  return first10 + check;
}
